var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { State, Action, Getter } from "vuex-class";
import { PrincipalService } from "~/services/domain-service/principal.service";
import { Emit } from "vue-property-decorator";
import AddAccount from '~/components/case-import/client-manage/add-account.vue';
import CommissionSet from '~/components/case-import/client-manage/commission-set.vue';
import { FileUploadService } from "~/services/file-service/file-upload.service";
var ModifyClient = /** @class */ (function (_super) {
    __extends(ModifyClient, _super);
    function ModifyClient() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.receivAccountRequest = [];
        _this.commissionDetail = [];
        //委托方数据实体
        _this.modifyModel = {
            name: "",
            principalCode: "",
            outSourceType: "",
            commonState: "",
            address: "",
            mail: "",
            collectArea: "",
            contents: "",
            contactName: "",
            phone: "",
            areaIds: [],
            companyCode: "",
            id: "",
            startTime: "",
            endTime: "",
            receivAccountsJson: "",
            paymentConfirmType: ''
        };
        //数据校验
        _this.rules = {
            name: [{ required: true, message: "请输入委托方", trigger: "blur" }],
            principalCode: [{ required: true, message: "请输入委托方代码", trigger: "blur" }],
            outSourceType: [{ required: true, message: "请选择机构类型", trigger: "change" }],
            commonState: [{ required: true, message: "请选择状态", trigger: "change" }],
            contactName: [{ required: true, message: "请输入联系人", trigger: "blur" }],
            phone: [{ required: true, message: "请输入正确的手机号", trigger: "blur", pattern: /^1(3|4|5|7|8)\d{9}$/ }],
            paymentConfirmType: [{ required: true, message: "请选择回款确认方式", trigger: "change" }],
        };
        return _this;
    }
    ModifyClient.prototype.refreshList = function () { };
    ModifyClient.prototype.close = function () {
        this.reset();
    };
    //重置方法
    ModifyClient.prototype.reset = function () {
        var modifyForm = this.$refs["modify-form"];
        modifyForm.resetFields();
        this.modifyModel.id = '';
        this.receivAccountRequest = [];
        this.commissionDetail = [];
    };
    /**
     * 反显数据
     */
    ModifyClient.prototype.update = function (data) {
        if (!data.id)
            return;
        this.modifyModel.name = data.name;
        this.modifyModel.address = data.address;
        this.modifyModel.contents = data.contents;
        this.modifyModel.phone = data.phone;
        this.modifyModel.companyCode = data.companyCode;
        this.modifyModel.id = data.id;
        this.modifyModel.principalCode = data.principalCode;
        this.modifyModel.outSourceType = data.outSourceType;
        this.modifyModel.commonState = data.commonState;
        this.modifyModel.mail = data.mail;
        this.modifyModel.areaId = data.areaId;
        this.modifyModel.startTime = this.$filter.dateTimeFormat(data.startTime);
        this.modifyModel.endTime = this.$filter.dateTimeFormat(data.endTime);
        this.modifyModel.collectArea = data.collectArea;
        this.modifyModel.contactName = data.contactName;
        this.modifyModel.paymentConfirmType = data.paymentConfirmType;
        var arr = this.$city.getCityParent(Number(data.areaId));
        this.modifyModel.areaIds = arr ? arr.concat([Number(data.areaId)]) : [];
        this.receivAccountRequest = data.receivAccounts || [];
        this.dataHandler();
        this.commissionDetail = data.commissionDetail;
    };
    /**
     * 收款账户回显数据处理
     */
    ModifyClient.prototype.dataHandler = function () {
        var _this = this;
        if (this.receivAccountRequest.length) {
            this.receivAccountRequest.map(function (v, index) {
                v.fileList = [];
                if (v.qrCodeUrl) {
                    // qrCodeUrl即为id
                    v.fileList.push({ response: { id: v.qrCodeUrl } });
                    // 根基ID查找url
                    _this.fileUploadService.getUploadFile(v.qrCodeUrl).subscribe(function (data) {
                        v.fileList[0].response.url = data.url;
                    });
                }
            });
        }
    };
    /**
     * 新增收款账户
     */
    ModifyClient.prototype.onClickAccount = function () {
        this.receivAccountRequest.push({
            id: '',
            paymentType: '',
            receiveName: '',
            receiveCardNumber: '',
            receiveBank: '',
            fileList: [],
            qrCodeUrl: ''
        });
    };
    /**
     * 新增佣金设置
     */
    ModifyClient.prototype.onClickCommision = function () {
        this.commissionDetail.push({
            overduePeriodStart: '',
            overduePeriodEnd: '',
            paymentAccountType: '',
            rate: '',
            id: ''
        });
    };
    ModifyClient.prototype.paramsHandler = function () {
        var params = __assign(__assign({}, this.modifyModel), { receivAccountRequest: this.receivAccountRequest, commissionDetail: this.commissionDetail });
        params.areaId = this.modifyModel.areaIds[this.modifyModel.areaIds.length - 1];
        if (params.receivAccountRequest.length) {
            params.receivAccountRequest.map(function (v, index) {
                v.qrCodeUrl = (v.fileList.length && v.fileList[0].response) ? v.fileList[0].response.id : '';
            });
        }
        params.startTime = this.$filter.dateFormat(this.modifyModel.startTime);
        params.endTime = this.$filter.dateFormat(this.modifyModel.endTime);
        delete params.areaIds;
        return params;
    };
    /**
     * 提交验证并并与数据库交互
     */
    ModifyClient.prototype.commit = function () {
        var _this = this;
        var modifyForm = this.$refs["modify-form"];
        modifyForm.validate(function (valid) {
            if (!valid)
                return false;
            var params = _this.paramsHandler();
            params.commissionDetail.map(function (v) {
                if (v.rate > 100)
                    return _this.$message.error('佣金比例不能大于100！');
            });
            //根据是否有数据传入决定执行新增还是修改
            _this.modifyModel.id ? _this.updateClient(params) : _this.addClient(params);
        });
    };
    /**
     * 新增委托方信息
     */
    ModifyClient.prototype.addClient = function (params) {
        var _this = this;
        this.principalService.addPrincipal(params).subscribe(function (data) {
            _this.$message.success("新增成功!");
            // 刷新列表
            _this.refreshList();
            // 刷新委托方列表
            _this.getPrincipalList();
            // 关闭
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    /**
     * 修改委托方信息
     */
    ModifyClient.prototype.updateClient = function (params) {
        var _this = this;
        this.principalService.updatePrincipal(params).subscribe(function (data) {
            _this.$message.success("修改成功!");
            // 刷新列表
            _this.refreshList();
            // 更新委托方缓存
            _this.getPrincipalList();
            //关闭
            _this.close();
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    __decorate([
        State
    ], ModifyClient.prototype, "companyList", void 0);
    __decorate([
        Action
    ], ModifyClient.prototype, "getPrincipalList", void 0);
    __decorate([
        Getter
    ], ModifyClient.prototype, "isSupperAdmin", void 0);
    __decorate([
        Dependencies(PrincipalService)
    ], ModifyClient.prototype, "principalService", void 0);
    __decorate([
        Dependencies(FileUploadService)
    ], ModifyClient.prototype, "fileUploadService", void 0);
    __decorate([
        Emit("refreshList")
    ], ModifyClient.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], ModifyClient.prototype, "close", null);
    ModifyClient = __decorate([
        Component({
            components: {
                AddAccount: AddAccount,
                CommissionSet: CommissionSet
            }
        })
    ], ModifyClient);
    return ModifyClient;
}(Vue));
export default ModifyClient;
